// extracted by mini-css-extract-plugin
export default {"inputs":"BaseForm_inputs__2qJu8","fixedLeft":"BaseForm_fixedLeft__LJhHK"};